<template>

	<div class="main-contents">
		<div class="mem_container prj_sp">
			<div style="display: flex; width: 1200px; margin: 0 auto;">
				<div class="contents-body demand tab flex mx-0">
					<ProjectInfo :projectSeq="projectSeq" type="7" @goList="$router.go(-1)" @prjSideInfo="setPrjSideInfo"/>
				</div>

				<div class="sticky-btn" style="height: 250px;">
					<div class="deadline flex-col px-0 py-0">
						<div v-if="prjSideInfo.recrEndDateDiff >= 0">
							<span class="date">
								<img src="/images/tec/prj/date_color.png" alt="마감기간"/> 
								마감 <span class="period">{{prjSideInfo.recrEndDateDiff}}</span> 일 전
								<!-- 모집마감 -->
							</span>
						</div>
						<div>
							<span>
								<img src="/images/tec/prj/member_sm.png" alt="지원자수"/>
								지원자 <span class="member">{{prjSideInfo.appCount}}</span> 명
							</span>
						</div>
					</div>

					<div class="management mt-0"> 						
						<div class="manager">
							<span>
								담당 매니저 <strong>{{prjSideInfo.admMgrMberNm}}</strong>
							</span>
							IT프로를 위한 전담매니저가 <br />
							얼라이언스 전 과정을 지원해 드립니다.
						</div>
					</div>
				</div>
			</div>
			<div class="btn-prj-detail">
				<span class="btn-list">
					&lt; 목록보기
				</span>
			</div>
		</div>
	</div>

</template>

<script>

import ProjectInfo from '@/components/highpro/ProjectInfo.vue';

export default {

	components : {
		ProjectInfo
	},

	data() {
		return {
			projectSeq : 0,
			prjSideInfo : {}			
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
		if(this.$route.query.projectSeq != undefined && this.$route.query.projectSeq != '') {
			this.projectSeq = Number(this.$route.query.projectSeq);
		}		
	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		// 프로젝트정보
		setPrjSideInfo(prjSideData){
			this.prjSideInfo = prjSideData;
		},

	},
};
</script>
